/**
 * Gets {@link ItemWorkflowVirtualizedTable}'s selected row styles for **outline**.
 */
export const getSelectedRowOutlineStyles = (theme) => ({
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '-2px',
    borderRadius: `var(--gp-radius-md)`,
});
